import React, { useContext } from "react";
import PrivacyPolicyIllustration from "../../../svg/PrivacyPolicyIllustration.svg";
import TCCSupportEmailLink from "../../components/TCCSupportEmailLink";
import TCCSupportPhoneLink from "../../components/TCCSupportPhoneLink";
import TCCSupportAddress from "../../components/TCCSupportAddress";
import WindowSizeContext from "../../contexts/windowSizeContext";
import { Link } from "gatsby";
import { v4 as uuidv4 } from "uuid";
import { window } from "browser-monads";

const PrivacyPolicyContent = (props) => {
  const { siteUrl } = props;
  const windowSize = useContext(WindowSizeContext);

  if (typeof window === `undefined`) {
    return <></>;
  }

  return (
    <div className="container mx-auto">
      <div className="w-full px-2 py-4 lg:pt-10">
        <div className="flex flex-wrap overflow-hidden">
          <div className="w-full overflow-hidden lg:w-7/12 xl:w-7/12">
            <h1 className={`${windowSize.isLargeScreenView ? `pl-0` : `pl-2`}`}>Privacy Policy</h1>
            <h2 className="text-lg text-blue-500">Our promise to you</h2>
            <p className="">
              Protecting your private information is our priority. This Statement of Privacy applies to <Link to="/">{siteUrl}</Link> and The Comparison Company Inc and governs data collection and
              usage. For the purposes of this Privacy Policy, unless otherwise noted, all references to The Comparison Company Inc include <Link to="/">{siteUrl}</Link> and TCC. The TCC website is a
              Price Comparison site. By using the TCC website, you consent to the data practices described in this statement.
            </p>
          </div>
          <div className={`${windowSize.isLargeScreenView ? `` : `hidden`} w-full overflow-hidden lg:w-5/12 xl:w-5/12`}>
            <PrivacyPolicyIllustration className="h-64 ml-auto" />
          </div>
        </div>
        <h3 className="">Collection of your Personal Information</h3>
        <p className="">TCC may collect anonymous demographic information, which is not unique to you, such as your:</p>
        <ul className="">
          <li key={uuidv4()}>Age</li>
          <li key={uuidv4()}>Gender</li>
          <li key={uuidv4()}>Household Income </li>
        </ul>
        <p className="">
          We do not collect any personal information about you unless you voluntarily provide it to us. However, you may be required to provide certain personal information to us when you elect to use
          certain products or services available on the Site. These may include: (a) registering for an account on our Site; (b) entering a sweepstake or contest sponsored by us or one of our
          partners; (c) signing up for special offers from selected third parties; (d) sending us an email message; (e) submitting your credit card or other payment information when ordering and
          purchasing products and services on our Site. To wit, we will use your information for, but not limited to, communicating with you in relation to services and/or products you have requested
          from us. We also may gather additional personal or non-personal information in the future.
        </p>
        <h2 className="">Sharing Information with Third Parties</h2>
        <p className="">TCC does not sell, rent or lease its customer lists to third parties.  </p>
        <p className="">
          TCC may, from time to time, contact you on behalf of external business partners about a particular offering that may be of interest to you. In those cases, your unique personally
          identifiable information (e-mail, name, address, telephone number) is transferred to a third party. TCC may share data with trusted partners to help perform statistical analysis, send you
          email or postal mail, provide customer support, or arrange for deliveries. All such third parties are prohibited from using your personal information except to provide these services to TCC,
          and they are required to maintain the confidentiality of your information.  
        </p>
        <p className="">
          TCC may disclose your personal information, without notice, if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or
          comply with legal process served on TCC or the site; (b) protect and defend the rights or property of TCC; and/or (c) act under exigent circumstances to protect the personal safety of users
          of TCC, or the public.  
        </p>
        <h2 className="">Opt-Out of Disclosure of Personal Information to Third Parties </h2>
        <p className="">In connection with any personal information, we may disclose to a third party for a business purpose, you have the right to know:</p>
        <ul>
          <li key={uuidv4()}>The categories of personal information that we disclosed about you for a business purpose.</li>
        </ul>
        <p className="">
          You have the right under the California Consumer Privacy Act of 2018 (CCPA) and certain other privacy and data protection laws, as applicable, to opt-out of the disclosure of your personal
          information. If you exercise your right to opt-out of the disclosure of your personal information, we will refrain from disclosing your personal information, unless you subsequently provide
          express authorization for the disclosure of your personal information. To opt-out of the disclosure of your personal information, visit <Link to="/app/profile">this</Link> Web page.
        </p>
        <h2 className="">Tracking User Behavior </h2>
        <p className="">
          TCC may keep track of the websites and pages our users visit within TCC, in order to determine what TCC services are the most popular. This data is used to deliver customized content and
          advertising within TCC to customers whose behavior indicates that they are interested in a particular subject area.  
        </p>
        <h2 className="">Use of Cookies</h2>
        <p className="">
          The TCC website may use "cookies" to help you personalize your online experience. A cookie is a text file that is placed on your hard disk by a web page server. Cookies cannot be used to run
          programs or deliver viruses to your computer. Cookies are uniquely assigned to you, and can only be read by a web server in the domain that issued the cookie to you.
        </p>
        <p className="">
          One of the primary purposes of cookies is to provide a convenience feature to save you time. The purpose of a cookie is to tell the Web server that you have returned to a specific page. For
          example, if you personalize TCC pages, or register with TCC site or services, a cookie helps TCC to recall your specific information on subsequent visits. This simplifies the process of
          recording your personal information, such as billing addresses, shipping addresses, and so on. When you return to the same TCC website, the information you previously provided can be
          retrieved, so you can easily use the TCC features that you customized.
        </p>
        <p className="">
          You have the ability to accept or decline cookies. Most Web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. If you
          choose to decline cookies, you may not be able to fully experience the interactive features of the TCC services or websites you visit.
        </p>
        <h2 className="">Links</h2>
        <p className="">
          This website contains links to other sites. Please be aware that we are not responsible for the content or privacy practices of such other sites. We encourage our users to be aware when they
          leave our site and to read the privacy statements of any other site that collects personally identifiable information.
        </p>
        <h2 className="">Security of your Personal Information</h2>
        <p className="">TCC secures your personal information from unauthorized access, use, or disclosure. TCC uses the following methods for this purpose:</p>
        <ul>
          <li key={uuidv4()}>SSL Protocol</li>
        </ul>
        <p className="">
          When personal information (such as a credit card number) is transmitted to other websites, it is protected through the use of encryption, such as the Secure Sockets Layer (SSL) protocol.
        </p>
        <p className="">
          We strive to take appropriate security measures to protect against unauthorized access to or alteration of your personal information. Unfortunately, no data transmission over the Internet or
          any wireless network can be guaranteed to be 100% secure. As a result, while we strive to protect your personal information, you acknowledge that: (a) there are security and privacy
          limitations inherent to the Internet which are beyond our control; and (b) security, integrity, and privacy of any and all information and data exchanged between you and us through this Site
          cannot be guaranteed.
        </p>
        <h2 className="">Right to Deletion</h2>
        <p className="">Subject to certain exceptions set out below, on receipt of a verifiable request from you, we will:</p>
        <ul>
          <li key={uuidv4()}>Delete your personal information from our records; and </li>
          <li key={uuidv4()}>Direct any service providers to delete your personal information from their records.</li>
        </ul>
        <p className="">Please note that we may not be able to comply with requests to delete your personal information if it is necessary to:</p>
        <ul>
          <li key={uuidv4()}>
            Complete the transaction for which the personal information was collected, fulfill the terms of a written warranty or product recall conducted in accordance with federal law, provide a
            good or service requested by you, or reasonably anticipated within the context of our ongoing business relationship with you, or otherwise perform a contract between you and us;{" "}
          </li>
          <li key={uuidv4()}>Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity; or prosecute those responsible for that activity;</li>
          <li key={uuidv4()}>Debug to identify and repair errors that impair existing intended functionality;</li>
          <li key={uuidv4()}>Exercise free speech, ensure the right of another consumer to exercise his or her right of free speech, or exercise another right provided for by law;</li>
          <li key={uuidv4()}>Comply with the California Electronic Communications Privacy Act;</li>
          <li key={uuidv4()}>
            Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all other applicable ethics and privacy laws, when our deletion of
            the information is likely to render impossible or seriously impair the achievement of such research, provided we have obtained your informed consent;
          </li>
          <li key={uuidv4()}>Enable solely internal uses that are reasonably aligned with your expectations based on your relationship with us; </li>
          <li key={uuidv4()}>Comply with an existing legal obligation; or</li>
          <li key={uuidv4()}>Otherwise use your personal information, internally, in a lawful manner that is compatible with the context in which you provided the information.</li>
        </ul>
        <h2 className="">Children Under Thirteen </h2>
        <p className="">
          TCC does not knowingly collect personally identifiable information from children under the age of thirteen. If you are under the age of thirteen, you must ask your parent or guardian for
          permission to use this website.
        </p>
        <h2 className="">Disconnecting your TCC Account from Third Party Websites </h2>
        <p className="">
          You will be able to connect your TCC account to third party accounts. BY CONNECTING YOUR TCC ACCOUNT TO YOUR THIRD PARTY ACCOUNT, YOU ACKNOWLEDGE AND AGREE THAT YOU ARE CONSENTING TO THE
          CONTINUOUS RELEASE OF INFORMATION ABOUT YOU TO OTHERS (IN ACCORDANCE WITH YOUR PRIVACY SETTINGS ON THOSE THIRD PARTY SITES). IF YOU DO NOT WANT INFORMATION ABOUT YOU, INCLUDING PERSONALLY
          IDENTIFYING INFORMATION, TO BE SHARED IN THIS MANNER, DO NOT USE THIS FEATURE. You may disconnect your account from a third party account at any time. Users may learn how to disconnect their
          accounts from third-party websites by visiting their "My Account" page. Users may also contact us via email or telephone.
        </p>
        <h2 className="">Opt-Out &amp; Unsubscribe from Third Party Communications </h2>
        <p className="">
          We respect your privacy and give you an opportunity to opt-out of receiving announcements of certain information. Users may opt-out of receiving any or all communications from third-party
          partners of TCC by contacting us here:
        </p>
        <ul>
          <li key={uuidv4()}>
            <Link to="/app/profil">In your account profile</Link>
          </li>
          <li key={uuidv4()}>
            Via email at <TCCSupportEmailLink showIcon={false} />
          </li>
          <li key={uuidv4()}>
            Via phone at <TCCSupportPhoneLink showIcon={false} />
          </li>
        </ul>
        <h2 className="">E-mail Communications </h2>
        <p className="">
          From time to time, TCC may contact you via email for the purpose of providing announcements, promotional offers, alerts, confirmations, surveys, and/or other general communication. In order
          to improve our Services, we may receive a notification when you open an email from TCC or click on a link therein.
        </p>
        <p className="">
          If you would like to stop receiving marketing or promotional communications via email from TCC, you may opt out of such communications by Clicking the unsubscribe link within the email.
        </p>
        <h2 className="">External Data Storage Sites</h2>
        <p className="">We may store your data on servers provided by third party hosting vendors with whom we have contracted.</p>
        <h2 className="">Changes to this Statement</h2>
        <p className="">
          TCC reserves the right to change this Privacy Policy from time to time. We will notify you about significant changes in the way we treat personal information by sending a notice to the
          primary email address specified in your account, by placing a prominent notice on our site, and/or by updating any privacy information on this page. Your continued use of the Site and/or
          Services available through this Site after such modifications will constitute your: (a) acknowledgment of the modified Privacy Policy; and (b) agreement to abide and be bound by that Policy.
        </p>
        <h3 className="">Contact Us</h3>
        <h3 className="">Privacy</h3>
        <p className="">
          Your use of <Link to="/">{siteUrl}</Link> is subject to TCC's Privacy Policy. Please review our <Link to="/privacy-policy">Privacy Policy</Link>, which also governs the Site and informs
          users of our data collection practices.
        </p>
        <h3 className="">Contact Us</h3>
        <p className="lg:px-1">TCC welcomes your questions or comments regarding the Terms:  </p>
        <TCCSupportAddress className="px-4 py-4 text-blue-500" />
        <ul className="px-4 pb-2 list-none">
          <li key={uuidv4()}>
            <TCCSupportEmailLink showIcon={true} className="text-blue-500" />
          </li>
          <li key={uuidv4()}>
            <TCCSupportPhoneLink showIcon={true} className="text-blue-500" />
          </li>
        </ul>
        <h2>Effective date</h2>
        <h3 className="text-blue-500">July 7th, 2020</h3>
      </div>
    </div>
  );
};

export default PrivacyPolicyContent;
